import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class TaskPartnerCommentSyncService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public sync(taskId: string, comment: string): Observable<void> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/partner-comment-sync`;

    return this.client.post<void>(url, { comment }).pipe(
      catchError(error => throwError(() => handleProblem(error)))
    );
  }
}
